import React, { ReactNode, useEffect, useRef, useState } from 'react'
import {
  DatePickerCalendarWrapper,
  DatePickerPopover,
  DatePickerSvgIcon,
  DatePickerTrigger,
  PickerFieldContainer,
  PopoverDateInput,
  PopoverInputFooter,
  PopoverInputIcon,
  ReservationDatePickerGlobalStyle,
} from './style'

interface PickerFieldShellProps {
  id?: string
  value: string
  displayValue: string
  placeholder: string
  isInvalid?: boolean
  icon: ReactNode
  children: (close: () => void) => ReactNode
}

export const PickerFieldShell = ({
  id,
  value,
  displayValue,
  placeholder,
  isInvalid,
  icon,
  children,
}: PickerFieldShellProps): JSX.Element => {
  const [isOpen, setIsOpen] = useState(false)
  const containerRef = useRef<HTMLDivElement>(null)
  const close = (): void => setIsOpen(false)

  useEffect(() => {
    const handleClickOutside = (event: MouseEvent): void => {
      if (containerRef.current != null && !containerRef.current.contains(event.target as Node)) {
        close()
      }
    }

    document.addEventListener('mousedown', handleClickOutside)
    return () => { document.removeEventListener('mousedown', handleClickOutside) }
  }, [])

  return (
    <PickerFieldContainer ref={containerRef}>
      <ReservationDatePickerGlobalStyle />
      <DatePickerTrigger
        id={id}
        type="button"
        $isInvalid={isInvalid}
        $hasValue={Boolean(value)}
        aria-expanded={isOpen}
        aria-haspopup="dialog"
        onClick={() => setIsOpen(current => !current)}
      >
        <span>{displayValue || placeholder}</span>
        <DatePickerSvgIcon>{icon}</DatePickerSvgIcon>
      </DatePickerTrigger>

      {isOpen && (
        <DatePickerPopover className="res-datepicker-popover" role="dialog">
          <DatePickerCalendarWrapper>
            {children(close)}
          </DatePickerCalendarWrapper>
          <PopoverInputFooter>
            <PopoverDateInput readOnly value={displayValue} placeholder={placeholder} />
            <PopoverInputIcon>{icon}</PopoverInputIcon>
          </PopoverInputFooter>
        </DatePickerPopover>
      )}
    </PickerFieldContainer>
  )
}
